export const column = '--virtuoso-grid-container-column';
export const spacing = '--virtuoso-grid-container-spacing';
